import { useEffect } from 'react'
import { Subject } from 'rxjs'

const openFavoritesPopover$ = new Subject<void>()

export const openFavoritesPopover = (): void => {
  openFavoritesPopover$.next()
}

export const useOpenFavoritesPopoverSignal = (onOpen: () => void): void => {
  useEffect(() => {
    const subscription = openFavoritesPopover$.subscribe(onOpen)
    return () => subscription.unsubscribe()
  }, [onOpen])
}
